import {DateRange} from '../stores/TimeIntervalStore';
import {DiagramMode} from '../stores/store';
import {BackendFilter} from '../stores/GeneralSelectorTableStore';
import {Channel} from '../types/Channel';
import _ from 'lodash';
import {TableSortDirection} from '../types/Table';

export interface DataVersionInfo {
    channel?: Channel;
    mainDateRange?: DateRange;
    compareDateRange?: DateRange;
    diagramMode?: DiagramMode;
    sortAttribute?: string;
    sortDirection?: TableSortDirection;
    searchterm?: string;
    searchExactly?: boolean;
    tableFilter?: BackendFilter[];
    allowDateCompareRange?: boolean;
    differenceBetweenRequestedAndLoadedDiagramsDetected?: boolean;
    channelCompareNames?: string[];
    channelCompareTargetCurrency?: string;
    limit?: number;
    testId?: string;
    variantIds?: string[];
}
export default class DataVersionChecker {
    private dataVersionInfoList: DataVersionInfo[] = [];

    public addDataVersionInfo = (newDataVersionInfo: DataVersionInfo) => {
        const newDataVersionInfoChannel = newDataVersionInfo.channel;
        if (!newDataVersionInfoChannel) {
            return;
        }

        const newDataVersionInfoList = this.dataVersionInfoList.filter(
            (dataVersionInfo) => !dataVersionInfo.channel || dataVersionInfo.channel.name !== newDataVersionInfoChannel.name
        );
        newDataVersionInfoList.push(newDataVersionInfo);
        this.dataVersionInfoList = newDataVersionInfoList;
    };

    public checkIfDataVersionAlreadyExists = (dataVersionInfoToCheck: DataVersionInfo): boolean => {
        const dataVersionInfoToCheckChannel = dataVersionInfoToCheck.channel;
        if (!dataVersionInfoToCheckChannel) {
            return false;
        }

        const matchingDataVersionInfoFromList = this.dataVersionInfoList.find(
            (dataVersionInfo) => dataVersionInfo.channel !== undefined && dataVersionInfo.channel.name === dataVersionInfoToCheckChannel.name
        );

        if (matchingDataVersionInfoFromList) {
            return _.isEqual(dataVersionInfoToCheck, matchingDataVersionInfoFromList);
        }
        return false;
    };

    public clear() {
        this.dataVersionInfoList = [];
    }
}



// WEBPACK FOOTER //
// ./src/utility/DataVersionChecker.ts